import { type Row } from "@tanstack/react-table";
import { VirtualItem } from "@tanstack/react-virtual";
import { DynamicDataTableRow } from "./DynamicDataTableRow";
import { type RowInteraction } from "./types";

type DynamicDataTableBodyProps<TData extends object> = RowInteraction<TData> & {
	virtualRows: VirtualItem[];
	rows: Row<TData>[];
	width: number;
};

export const DynamicDataTableBody = <TData extends object>({
	virtualRows,
	rows,
	width,
	...rowInteraction
}: DynamicDataTableBodyProps<TData>) => {
	return (
		<div className="min-w-full h-full relative" style={{ width }}>
			{rows.length > 0 &&
				virtualRows.map((virtualRow) => {
					const row = rows[virtualRow.index];
					return (
						<DynamicDataTableRow
							key={row.id}
							height={virtualRow.size}
							translateY={virtualRow.start}
							row={row}
							{...rowInteraction}
						/>
					);
				})}
		</div>
	);
};
